import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type ProviderType = "foodics" | "blend" | "foodizone" | "deliverect" | null;

export interface OwnerState {
  accessToken: string;
  currentIntegrationId?: number | null;
  provider?: ProviderType;
}

const initialState: OwnerState = {
  accessToken: "",
  currentIntegrationId: null,
  provider: null,
};

const ownerSlice = createSlice({
  name: "owner",
  initialState,
  reducers: {
    loginOwner(
      state,
      action: PayloadAction<{ accessToken: string; currentIntegrationId?: number | null; provider?: ProviderType }>
    ) {
      state.accessToken = action.payload.accessToken;
      state.currentIntegrationId = action.payload.currentIntegrationId ?? null;
      state.provider = action.payload.provider ?? null;
    },
    logoutOwner(state) {
      state.accessToken = "";
      state.currentIntegrationId = null;
      state.provider = null;
    },
  },
});
export const { loginOwner, logoutOwner } = ownerSlice.actions;
export default ownerSlice.reducer;
